import Page from "~/pages/Page";
import { getApi, handleError, logout } from "~/auth";
import UI from "~/ui";
import $ from "jquery";
import * as bootstrap from "bootstrap";
import GraficoOfferte from "~/components/GraficoOfferte";
import { gotoLogin } from "~/utils";

class AdMonitoraVendita extends Page {
    private auth: any = null;
    private UserId: number = 0; // Aggiungi l'ID dell'utente
    private userInfo: any = null; // Variabile globale per memorizzare le informazioni dell'utente
    private venditaId: number = 0;
    constructor() {
        super("admonitoravendita", "AD Monitora Vendita");
    }

    pageStart(): Promise<void> {
        const that = this;
        this.auth = getApi();
        this.userInfo = this.auth.getCached("userInfo"); // Inizializza la variabile globale
        if (!this.userInfo) {
            gotoLogin();
            return Promise.reject("User not authenticated");
        }

        this.UserId = this.userInfo.anagraficaId; // Inizializza l'ID dell'utente

        this.venditaId = parseInt($("#hdVenditaId").val() as string, 10);

        this.InitGrafico();

        $(".btnRichiediCauzione").on("click", (e) => {
            e.preventDefault();
            const offertaId: number = parseInt($(e.currentTarget).data("id"), 10);

            if (offertaId) {
                UI.confirmWithButtonOkCustom("Richiedi proposta", "Procedendo, inviterai l’offerente a formalizzare la sua manifestazione di interesse tramite una proposta irrevocabile di acquisto.", "Richiedi proposta", "modal-lg", (result) => {
                    if (!result) {
                        return;
                    }
                    this.InviaPropostaCauzionata(offertaId);
                });
            } else {
                UI.confirmOneButton("", "Nessuna offerta selezionata per la richiesta di cauzione"); //TODO: i18n
            }
        })

        $(".btnMiglioreOfferta").on("click", (e) => {
            e.preventDefault();
            const offertaId: number = parseInt($(".btnMiglioreOfferta").data("id") as string, 10);

            if (offertaId) {
                this.MiglioreOfferta(offertaId);
            } else {
                UI.confirmOneButton("", "Non è stata selezionata nessuna offerta"); //TODO: i18n
            }
        })


        $(".btnInvitaAllAsta").on("click", (e) => {
            e.preventDefault();
            if (this.venditaId) {
                this.InvitaAllAsta(this.venditaId);
            } else {
                UI.confirmOneButton("", "Errore nel recupero dei dati"); //TODO: i18n
            }
        })

        $("#modal_invitaallasta").on("hidden.bs.modal", function () {
            // Rimuovi manualmente il backdrop se rimane
            $(".modal-backdrop").remove();
            $("body").removeClass("modal-open").css("overflow", "");
            $("body").css("padding-right", "");
        });


        $(".btnPassaOfferteAT").on("click", (e) => {
            e.preventDefault();
            // Chiudi la modale usando Bootstrap 5
            const modalElement = document.getElementById("modal_invitaallasta");
            if (modalElement) {
                const modal = bootstrap.Modal.getInstance(modalElement);
                if (modal) modal.hide();
            }

            const venditaId: any = $("#hdVenditaId").val();
            if (venditaId) {
                console.info("VenditaId --> " + venditaId);
                this.RichiestaAstaTelematica(venditaId);
            }
        })

        return Promise.resolve();
    }

    private async InviaPropostaCauzionata(offertaId: number): Promise<void> {
        let _ = this.spinner.spin();
        const url = window.BaseUrlWebApi + "AstaDinamica/RichiediPropostaCauzionata?offertaId=" + offertaId;
        const response = await this.auth.fetchWithAuth("GET " + url, {
            cache: "no-cache",
            headers: { 'content-type': 'application/json' },
        });

        this.spinner.stop();

        if (response.size === 0) {

            UI.confirmOneButton("Richiesta inviata", "La tua richiesta è stata inviata all'offerente. Riceverai una notifica nel caso l'offerente accetti la tua richiesta.", "", function (result) {
                if (result) {
                    window.location.reload();
                }
            });
        } else {
            UI.confirmOneButton("", "Errore durante l'invio della proposta di acquisto");
        }

    }

    private async AccettaOfferta(offertaId: number): Promise<void> {

            UI.confirmOneButton("", "Sei sicuro di voler accettare questa offerta?", "", function (result) {
                if (result) {
                    window.location.href = window.BaseUrlWeb + "carica-proposta-controfirmata-" + offertaId;
                }
            });

    }

    private async MiglioreOfferta(offertaId: number): Promise<void> {
        let _ = this.spinner.spin();
        const url = window.BaseUrlWebApi + "AstaDinamica/SelezionaMiglioreOfferta?offertaId=" + offertaId;
        const response = await this.auth.fetchWithAuth("GET " + url, {
            cache: "no-cache",
            headers: { 'content-type': 'application/json' },
        });

        if (response.size === 0) {
            
            UI.confirmOneButton("", "Offerta selezionata con successo", "", function (result) {
                if (result) {
                    window.location.reload();
                }
            });
        }

        this.spinner.stop();
    }

    private async InvitaAllAsta(venditaId: number): Promise<any> {
        let _ = this.spinner.spin();
        const url = window.BaseUrlWebApi + "AstaDinamica/GetOfferteValide?venditaId=" + venditaId;
        const response = await this.auth.fetchWithAuth("GET " + url, {
            cache: "no-cache",
            headers: { 'content-type': 'application/json' },
        });

        if (response.length > 0) {
            try {
                const offerte = response;
                var tBody = "";
                offerte.forEach(function callbackFn(element: any) {
                    tBody += "<tr id=" + element.OffertaAstaDinamica.Id + " data-offertaid='" + element.OffertaAstaDinamica.Id + "'>";
                    tBody += "<td data-label='Utente' class='d-block d-sm-table-cell'>" + element.Utente + "</td>";
                    tBody += "<td data-label='Importo offerto'>" + UI.formatEuroCurrency(element.OffertaAstaDinamica.PrezzoOfferto) + "</td>";
                    tBody += "<td data-label='Importo cauzione'>" + UI.formatEuroCurrency(element.OffertaAstaDinamica.ImportoCauzione) + "</td>";
                    tBody += "<td data-label='Tempo rogito/consegna' class='col-hide-sm'>" + (element.OffertaAstaDinamica.PeriodoRogito != 5 ? "entro " + (element.OffertaAstaDinamica.PeriodoRogito * 3) + "  mesi" : "oltre 12 mesi") + "</td>";
                    tBody += "</tr>";
                    tBody += "<tr class='expand-row-details d-none'>";
                    tBody += "<td colspan='4' class='bg-body-secondary px-5 lh-lg small'></td>";
                    tBody += "</tr>";
                });

                $("#tbodyOfferteValide").html(tBody);

                // Apri la modale usando Bootstrap 5
                const modalElement = document.getElementById("modal_invitaallasta");
                if (modalElement) {
                    const modal = new bootstrap.Modal(modalElement);
                    modal.show();
                }

            } catch (e) {
                console.info("Errore durante il recupero delle offerte:", e);
            } finally {
                this.spinner.stop();
            }
        } else {
            UI.confirmOneButton("", "Non ci sono offerte valide per questa vendita");
            this.spinner.stop();
        }

    }

    private async RichiestaAstaTelematica(venditaId: number): Promise<any> {
        let _ = this.spinner.spin();
        try {
            const url = window.BaseUrlWebApi + "AstaDinamica/RichiestaAttivazioneAt?venditaId=" + venditaId;
            const response = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (response.size === 0) {
                UI.confirmOneButton("", "La tua richiesta di attivazione dell’asta telematica classica è andata a buon fine!<br />Lo Staff procederà a predisporla e potrai monitorarne l’andamento tramite la tua area riservata.", "modal-lg", function (result) {
                    if (result) {
                        window.location.href = '/monitora-vendita-' + venditaId;
                    }
                })
            }
        } finally {
            this.spinner.stop();
        }
    }
    private async InitGrafico() {
        const that = this;
        const chartData: any = (window as any).chartData;
        // ID del contenitore HTML dove verrà renderizzato il grafico
        const containerId = "chartdiv";
        // Inizializza le variabili con i dati recuperati
        const ChartSeries = chartData.chartSeries;
        const MaxOfferta = chartData.maxOfferta;
        const MinOfferta = chartData.minOfferta;
        const MinMedia = chartData.minMedia;
        const PrezzoRichiesto = chartData.prezzoRichiesto;
        const TempoRichiesto = chartData.tempoRichiesto;

        const grafico = new GraficoOfferte(
            containerId,
            PrezzoRichiesto,
            TempoRichiesto,
            MaxOfferta,
            MinOfferta,
            MinMedia,
            ChartSeries
        );

        // Inizializzazione del grafico
        grafico.initGrafico(
            PrezzoRichiesto,
            TempoRichiesto,
            MaxOfferta,
            MinOfferta,
            MinMedia,
            ChartSeries);
    }


}

export default AdMonitoraVendita;